<app-checkbox
	*ngIf="!downloading && !success"
	type="clear"
	[ngModel]="selected"
></app-checkbox>
<app-icon *ngIf="downloading" [icon]="ICON.LOADING" [spin]="true"></app-icon>
<app-icon *ngIf="success && !downloading" [icon]="ICON.SUCCESS"></app-icon>
